import produce from 'immer';
import {
  listVideo,
  setVideo,
  setOrder,
  setSort,
  setCount,
  setSkip,
} from './actions';

/* eslint-disable default-case */

const initialState = {
  loading: false,
  error: null,
  items: [],
  item: null,
  order: null,
  sort: null,
  skip: 0,
  count: 0,
};

const reducer = produce((draft, { type, payload }) => {
  switch (type) {
    case listVideo.TRIGGER:
      draft.loading = true;
      draft.error = null;
      break;
    case listVideo.SUCCESS:
      draft.items = payload;
      break;
    case listVideo.FAILURE:
      draft.error = payload;
      break;
    case listVideo.FULFILL:
      draft.loading = false;
      break;
    case setVideo.toString():
      draft.item = payload;
      break;
    case setOrder.toString():
      draft.order = payload;
      break;
    case setSort.toString():
      draft.sort = payload;
      break;
    case setCount.toString():
      draft.count = payload;
      break;
    case setSkip.toString():
      draft.skip = payload;
      break;
    // no default
  }
}, initialState);

export default reducer;
